const LoaderShimmer = ({ width = "100%", height = "100%", className = "" }) => {
  return (
    <div className={`placeholder-glow ${className}`} style={{width, height}}>
      <span
        className="placeholder d-block"
        style={{
          width,
          height,
          display: "block",
        }}
      />
    </div>
  );
};

export default LoaderShimmer;
